export default {"src":"/_next/static/media/telegramIcon.fc0f1aec.svg","height":16,"width":16};